<template>
    <textarea :id="id" v-model="getData" class="msgError" :style="{height:height}"></textarea>
</template>

<script>
import cTinymce from "tinymce";
export default{
    props:[
        "height",
        "inputData",
        "toolbarRequired",
        "autoResize",
        "className",
        "isDisabled"
    ],
    data() {
        return {
            id: 'editor_' + __.random(10000, 99999),
            getData:'',
            newId :''
        }
    },
    computed:{
        toolBarData(){
            if(this.toolbarRequired == true){
                return ' bold | italic | underline | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | fontselect | fontsizeselect | link image'
            }
            else
              return false
        },
        disabled(){
            if(this.isDisabled == true){
                return 1
            }
        }
        //getData(){
        //    if(this.inputData != null)
        //        return this.inputData
        //}
        },
    watch:{
        inputData(val){
            this.getData = val
            if(this.newId == `${this.id}body_content`){
                tinymce.get(this.id).setContent(this.getData)
            }

            this.$emit('textareaInput', this.getData)
        }
    },
    created(){
        if(this.inputData != null)
            this.getData = this.inputData
    },
    mounted() {
        this.newId = `${this.id}${this.className}`;
        var vm=this;
        if(this.autoResize == true){
            tinymce.init({
                selector:"#"+ vm.id,
                menubar: false,
                theme: "silver",
                paste_data_images: true,
                plugins:'autoresize',
                autoresize_bottom_margin:10,
                autoresize_min_height: 50,
                autoresize_max_height: 999999,
                autoresize_on_init:true,
                statusbar: false, //to hide status bar
                setup: function (editor) {
                    editor.on('init', function () {
                        this.getDoc().body.style.fontSize = '12px';
                        this.getDoc().body.style.fontFamily = 'Open Sans';
                        vm.getData= editor.getContent();
                        vm.$emit('textareaInput', vm.getData);
                    });
                    editor.on('change', function () {
                        vm.getData= editor.getContent();
                        vm.$emit('textareaInput', vm.getData);
                        editor.save();
                    });
                    editor.on('blur', function () {
                        vm.getData= editor.getContent();
                        //vm.$emit('textareaInput', vm.getData);
                    });
                },
                plugins: [
                    'autoresize advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'textcolor colorpicker',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern'

                ],
                toolbar: this.toolBarData,
                style_formats : [
                            {title : 'Line height 20px', selector : 'p,div,h1,h2,h3,h4,h5,h6', styles: {lineHeight: '20px', padding:'0px'}},
                            {title : 'Line height 30px', selector : 'p,div,h1,h2,h3,h4,h5,h6', styles: {lineHeight: '30px', padding:'3px'}}
                ],
                fontsize_formats: '8px 10px 12px 14px 18px',
                font_formats:"Arial=arial,helvetica,sans-serif;"+
                        "Georgia=georgia,palatino;"+
                        "Helvetica=helvetica;"+
                        "Tahoma=tahoma,arial,helvetica,sans-serif;"+
                        "Verdana=verdana,geneva;" +
                        "Times New Roman=times new roman,times;" + "Open Sans=Open Sans, sans-serif;",
                image_advtab: true,
            });
        }
        else{
            tinymce.init({
                selector:"#"+ vm.id,
                 height: vm.height,
                menubar: false,
                theme: "silver",
                paste_data_images: true,
                statusbar: false, //to hide status bar
                setup: function (editor) {
                    editor.on('init', function () {
                        this.getDoc().body.style.fontSize = '12px';
                        this.getDoc().body.style.fontFamily = 'Open Sans';
                        vm.getData= editor.getContent();
                        vm.$emit('textareaInput', vm.getData);
                    });
                    editor.on('change', function () {
                        vm.getData= editor.getContent();
                        vm.$emit('textareaInput', vm.getData);
                        editor.save();
                    });
                    editor.on('blur', function () {
                        vm.getData= editor.getContent();
                        //vm.$emit('textareaInput', vm.getData);
                    });
                },
                plugins: [
                    'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                    'textcolor colorpicker',
                    'searchreplace wordcount visualblocks visualchars code fullscreen',
                    'insertdatetime media nonbreaking save table contextmenu directionality',
                    'emoticons template paste textcolor colorpicker textpattern'

                ],
                toolbar: this.toolBarData,
                style_formats : [
                            {title : 'Line height 20px', selector : 'p,div,h1,h2,h3,h4,h5,h6', styles: {lineHeight: '20px', padding:'0px'}},
                            {title : 'Line height 30px', selector : 'p,div,h1,h2,h3,h4,h5,h6', styles: {lineHeight: '30px', padding:'3px'}}
                ],
                fontsize_formats: '8px 10px 12px 14px 18px',
                font_formats:"Arial=arial,helvetica,sans-serif;"+
                        "Georgia=georgia,palatino;"+
                        "Helvetica=helvetica;"+
                        "Tahoma=tahoma,arial,helvetica,sans-serif;"+
                        "Verdana=verdana,geneva;" +
                        "Times New Roman=times new roman,times;" + "Open Sans=Open Sans, sans-serif;",
                image_advtab: true,
                readonly:this.disabled
            });
        }

    },
    methods: {
        resetTinymce() {
            tinymce.get(this.id).setContent('')
        }
    }
 }
</script>



// WEBPACK FOOTER //
// src/Components/tinymce.vue